'use strict';

define(['plugins/loader', 'plugins/model', 'plugins/plugin', 'plugins/utils'], function (PluginsLoader, PluginsModel, Plugin, pluginsUtils) {

    var _plugins = {},
        _pluginLoaders = {};

    var loadPlugins = function loadPlugins(id, config) {
        _pluginLoaders[id] = new PluginsLoader(new PluginsModel(_plugins), config);
        return _pluginLoaders[id];
    };

    var registerPlugin = function registerPlugin(id, target, arg1, arg2) {
        var pluginId = pluginsUtils.getPluginName(id);
        if (!_plugins[pluginId]) {
            _plugins[pluginId] = new Plugin(id);
        }
        _plugins[pluginId].registerPlugin(id, target, arg1, arg2);
    };

    return {
        loadPlugins: loadPlugins,
        registerPlugin: registerPlugin
    };
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/plugins/plugins.js
 ** module id = 92
 ** module chunks = 0
 **/